import * as React from "react";

import Select from "react-select";
import { ControlLabel } from 'react-bootstrap';
import styled from "styled-components";

const StyledContainer = styled.div`
  width: 75%;
`;

type Props = {
  options: Array<{value:string, label:string}>,
  value: string | undefined,
  name:string,
  label:string,
  placeholder:string,
  handleSelectOption: (option:string)=>void
}

export default function ValueSelector({options, value,name,label, placeholder, handleSelectOption}:Props){
  const selectedPaymentMethod = options.find(
    o => o.value === value
  );
  return (
    <StyledContainer>
      <ControlLabel htmlFor={name}>{label}</ControlLabel>
      <Select
        name={name}
        options={options}
        defaultValue={selectedPaymentMethod}
        placeholder={placeholder}
        onChange={selectedOption => {
          if (!selectedOption?.value) return;
          handleSelectOption(selectedOption.value);
        }}
      />
    </StyledContainer>
  );
}